import React from 'react'

export const ProfileDropdownClubCardPlus = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8525 9.44275C20.8525 11.8965 18.8541 13.8857 16.3891 13.8857C13.9241 13.8857 11.9258 11.8965 11.9258 9.44275C11.9258 6.98898 13.9241 4.99976 16.3891 4.99976C18.8541 4.99976 20.8525 6.98898 20.8525 9.44275Z"
        fill="#F4AF25"
      />
      <path
        d="M20.8534 9.44312C20.8534 14.3507 16.8568 18.3291 11.9267 18.3291C6.99661 18.3291 3 14.3507 3 9.44312C3 6.98935 4.99827 5.00012 7.46335 5.00012C9.92836 5.00012 11.9267 6.98935 11.9267 9.44312C11.9267 11.8969 13.925 13.8861 16.39 13.8861C18.8551 13.8861 20.8534 11.8969 20.8534 9.44312Z"
        fill="#2C3490"
      />
    </svg>
  )
}
